import classnames from "classnames";
import moment from "moment";
import { Image } from "uikit-react";

import FeatherIcon from "../../common/FeatherIcon";

export const SMSThreadCard = ({
  thread,
  selected,
  handleSelect,
  togglePersonalMeta,
}) => {
  var {
    contact_first_name,
    contact_last_name,
    guest_first_name,
    guest_last_name,
    formatted_contact_phone,
    formatted_guest_phone,
    last_msg,
  } = thread;

  var firstName =
    contact_first_name ||
    guest_first_name ||
    formatted_contact_phone ||
    formatted_guest_phone ||
    "[Unknown]";

  var lastName = contact_last_name || guest_last_name || "";

  return (
    <div
      className={classnames("chat-guest-contact-wrapper", {
        "active-chat-guest-contact": selected,
        "thread-unread": thread.meta_values.indexOf("unread") >= 0,
      })}
      key={thread.id}
    >
      <div
        className="message-text-group"
        onClick={() => {
          handleSelect(thread.id);
        }}
      >
        <span
          className="message-text-group-icon"
          uk-tooltip={`title: ${
            thread.contact_category
              ?.toLowerCase()
              .replace(/\b\w/g, (s) => s.toUpperCase()) || "Guest"
          }; pos: bottom-left; cls: uk-active contact-tooltip`}
        >
          {thread.contact_category !== null ? (
            <Image src={`/images/${thread.contact_category}-active.svg`} />
          ) : (
            <Image src="/images/guest-active.svg" />
          )}
        </span>
        <div>
          <div className="semi-bold-font">
            {[firstName, lastName].join(" ")}
          </div>
          {thread.contact_category === null &&
            thread.current_reservation_count > 0 &&
            (thread.current_reservation_count > 1 ? (
              <div className="chat-guest-contact-address uk-margin-tiny-top uk-margin-tiny-bottom">
                Multiple Current Bookings
                <img
                  class="info-icon"
                  src="/images/info-icon.svg"
                  alt="info"
                  uk-tooltip={`${thread.current_reservation_count} Current Bookings. See the right side for Property IDs.`}
                  title=""
                  aria-describedby="uk-tooltip-134"
                  tabindex="0"
                />
              </div>
            ) : (
              <div
                className="chat-guest-contact-address uk-margin-tiny-top uk-margin-tiny-bottom"
                uk-tooltip={thread?.unit_code}
              >
                {thread?.unit_code.length > 30
                  ? `${thread.unit_code.slice(0, 30)}`
                  : thread?.unit_code}
              </div>
            ))}
          <div
            className={
              thread.meta_values.indexOf("unread") >= 0
                ? "chat-guest-unread-message"
                : "chat-guest-message"
            }
          >
            {last_msg?.length > 60 ? `${last_msg.slice(0, 60)}...` : last_msg}
          </div>
          <div className="chat-guest-handled">
            {thread.meta_values.indexOf("unhandled") === -1 && (
              <span aria-label="Handled" uk-tooltip="Handled">
                <FeatherIcon
                  name="check"
                  className="handled-icon"
                  color="#28a745"
                />
              </span>
            )}
          </div>
          <div className="chat-guest-contact-date">
            {moment
              .utc(thread.last_message_on)
              .local()
              .format("MMM DD, YYYY hh:mm a")}
          </div>
        </div>
      </div>
      <div className="messages-btn-group">
        <span className="hms-simple-icon-btn inbox-read-state-indicator">
          {thread.meta_values?.indexOf("unread") >= 0 ? (
            <span className="inbox-unread-dot" />
          ) : (
            <FeatherIcon
              name="mail"
              className="inbox-action-icon inbox-read-state-icon"
              color="inherit"
            />
          )}
        </span>
        <button
          className={classnames("uk-button hms-simple-icon-btn", {
            "icon-active icon-priority":
              thread.meta_values.indexOf("priority") >= 0,
          })}
          onClick={() => togglePersonalMeta(thread.id, "priority", true)}
          uk-tooltip={
            thread.meta_values.indexOf("priority") >= 0
              ? "Unprioritize"
              : "Prioritize"
          }
        >
          <FeatherIcon
            name="flag"
            className="inbox-action-icon"
            color="inherit"
          />
        </button>
        <button
          className={classnames("uk-button hms-simple-icon-btn", {
            "icon-active icon-archived":
              thread.meta_values.indexOf("archived") >= 0,
          })}
          onClick={() => togglePersonalMeta(thread.id, "archived")}
          uk-tooltip={
            thread.meta_values.indexOf("archived") >= 0
              ? "Unarchive"
              : "Archive"
          }
        >
          <FeatherIcon
            name="archive"
            className="inbox-action-icon"
            color="inherit"
          />
        </button>
      </div>
    </div>
  );
};
